export const SHOW_VALUES = ["Proposal", "Evaluation", "Buttons", "FuturePlan"];

export const SHOW_ALIASES = {
  "Future Plan": "FuturePlan",
};

export const STATUS_BY_SHOW = {
  Proposal: ["Draft", "PendingApprovals", "Rejected", "PendingReconciliation"],
  Evaluation: ["NotEligible", "Eligible"],
  Buttons: ["ProposeChanges", "ProposeFirstPlan", "ProposePayPlan"],
  FuturePlan: ["N/A"],
};

export const STATUS_ALIASES = {
  "Pending Approvals": "PendingApprovals",
  "Pending Reconciliation": "PendingReconciliation",
  "Not Eligible": "NotEligible",
  "Propose Changes": "ProposeChanges",
  "Propose First Plan": "ProposeFirstPlan",
  "Propose Pay Plan": "ProposePayPlan",
};

export const STATUS_LABELS = {
  Draft: "Draft",
  PendingApprovals: "Pending Approvals",
  Rejected: "Rejected",
  PendingReconciliation: "Pending Reconciliation",
  NotEligible: "Not Eligible",
  Eligible: "Eligible",
};

export const TOOLTIPS = {
  Proposal: {
    title: "Pay Plan Change Proposal",
    statusPrefix: "Status: ",
    action: "Click to drill down into proposal",
  },
  Evaluation: {
    title: "Pay Plan Change Evaluation",
    statusPrefix: "Status: ",
    action: "Click to drill down into evaluation",
  },
  FuturePlan: {
    title: "Upcoming Pay Plan",
    action: "Click to drill down into Pay Plan version",
  },
};

export const VALID_STATUSES = Object.values(STATUS_BY_SHOW).flat();
